import { Languages } from "../types";
import { getMedicalAreaReportsPagesDescriptions } from "./MedicalArea";
import { ReportPagesDescriptions } from "./types";

export const getReportsPagesDescriptions = (systemLang: Languages): ReportPagesDescriptions => ({
    MEDICAL_AREA: getMedicalAreaReportsPagesDescriptions(systemLang),
})